// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + "nri" + "-" + "c9f09e0e19bb1b55ae01" + ".js";
};